import { render } from "./MessageGroupAddPeople.vue?vue&type=template&id=21de773e&scoped=true&ts=true"
import script from "./MessageGroupAddPeople.vue?vue&type=script&lang=ts"
export * from "./MessageGroupAddPeople.vue?vue&type=script&lang=ts"

import "./MessageGroupAddPeople.vue?vue&type=style&index=0&id=21de773e&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21de773e"]])

export default __exports__